import { render, staticRenderFns } from "./matricula-gpln.vue?vue&type=template&id=185bfc42&"
import script from "./matricula-gpln.component.ts?vue&type=script&lang=ts&"
export * from "./matricula-gpln.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports